import React from "react";
import { Box, Button, Chip, Container, Paper, Stack, Typography } from "@mui/material";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import MarkEmailReadOutlinedIcon from "@mui/icons-material/MarkEmailReadOutlined";
import WebOutlinedIcon from "@mui/icons-material/WebOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import RocketLaunchOutlinedIcon from "@mui/icons-material/RocketLaunchOutlined";

const steps = [
  { icon: EmailOutlinedIcon, title: "Creá tu cuenta", text: "Registrate con tu email y entrá al panel de WebProfit." },
  { icon: MarkEmailReadOutlinedIcon, title: "Confirmá tu email", text: "Validamos tu acceso y dejamos tu espacio listo para trabajar." },
  { icon: WebOutlinedIcon, title: "Creá tu página", text: "Elegí el nombre, la identidad y la estructura inicial de tu negocio." },
  { icon: Inventory2OutlinedIcon, title: "Cargá lo que vendés", text: "Sumá productos o servicios con precios, imágenes y detalles." },
  { icon: RocketLaunchOutlinedIcon, title: "Publicá y avanzá", text: "Revisá el progreso, completá lo pendiente y activá tu web." },
];

export default function StepsSection({
  onStartClick,
  primaryLabel = "Empezar por mi cuenta",
  isAuthenticated = false,
}) {
  return (
    <Box id="como-funciona" component="section" sx={{ py: { xs: 8, md: 12 }, scrollMarginTop: 90 }}>
      <Container maxWidth="lg">
        <Box sx={{ maxWidth: 760, mx: "auto", textAlign: "center" }}>
          <Chip label="Un paso claro por vez" sx={{ bgcolor: "rgba(243,90,58,.09)", color: "#C83E21", fontWeight: 900 }} />
          <Typography sx={{ mt: 2, color: "#19242F", fontWeight: 950, letterSpacing: "-.045em", lineHeight: 1.05, fontSize: { xs: "2.15rem", md: "3.4rem" } }}>
            No te dejamos frente a un panel vacío.
          </Typography>
          <Typography sx={{ mt: 2, color: "rgba(25,36,47,.67)", fontSize: { xs: "1rem", md: "1.12rem" }, lineHeight: 1.7 }}>
            Cada etapa te muestra qué falta, qué ya completaste y cuál es la acción que te hace avanzar.
          </Typography>
        </Box>

        <Box sx={{ mt: { xs: 5, md: 7 }, display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(2,1fr)", lg: "repeat(5,1fr)" }, gap: 2 }}>
          {steps.map(({ icon: Icon, title, text }, index) => (
            <Paper key={title} elevation={0} sx={{ position: "relative", p: 2.5, borderRadius: 4, border: "1px solid rgba(25,36,47,.09)", bgcolor: index === 2 ? "#FFF7F3" : "#fff", boxShadow: "0 14px 36px rgba(25,36,47,.06)", minHeight: 230 }}>
              <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Box sx={{ width: 48, height: 48, borderRadius: 3, display: "grid", placeItems: "center", bgcolor: index <= 2 ? "#F35A3A" : "rgba(25,36,47,.08)", color: index <= 2 ? "#fff" : "#19242F" }}>
                  <Icon />
                </Box>
                <Typography sx={{ color: "rgba(25,36,47,.28)", fontWeight: 950, fontSize: "1.7rem" }}>0{index + 1}</Typography>
              </Stack>
              <Typography sx={{ mt: 2.5, color: "#19242F", fontWeight: 900, fontSize: "1.08rem", lineHeight: 1.2 }}>{title}</Typography>
              <Typography sx={{ mt: 1, color: "rgba(25,36,47,.64)", fontSize: ".91rem", lineHeight: 1.6 }}>{text}</Typography>
            </Paper>
          ))}
        </Box>

        <Stack alignItems="center" spacing={1.2} sx={{ mt: 5 }}>
          <Button onClick={onStartClick} variant="contained" size="large" endIcon={<ArrowForwardRoundedIcon />} sx={{ minHeight: 54, px: 3.5, borderRadius: 999, bgcolor: "#F35A3A", textTransform: "none", fontWeight: 900, boxShadow: "0 14px 30px rgba(243,90,58,.25)", "&:hover": { bgcolor: "#DF4728" } }}>
            {primaryLabel}
          </Button>
          <Typography sx={{ color: "rgba(25,36,47,.52)", fontSize: ".85rem" }}>{isAuthenticated
              ? "Tu sesión está activa: podés volver al panel sin iniciar sesión otra vez."
              : "Guardamos tu progreso para que continúes cuando quieras."}</Typography>
        </Stack>
      </Container>
    </Box>
  );
}
